import { Utils } from '../../../../../../../utils/utils';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class SentimentPolaritySummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: any) {
    const translationKey = `widgets.ai-insights.summary.${widget.payload.type}`;

    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => ({
        translationKey: `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`,
        translationParams: {
          fieldValue: p.pointId,
          score: Utils.round(p.y),
          sentiment: p.series.name,
        },
      }));
  }
}
